module.exports = __webpack_public_path__ + "img/release-link.dcb5dce0.png";